export default __webpack_public_path__ + "static/media/MS.46b89775.svg";